import { getAnalyticsPlugin } from '@/app/(main)/_components/logger/analytics/get-analytics-plugin';
import { getLogger } from '@/logger/logger';
import { CartPurchaseTrack } from '@/types/cart.types';

const logger = getLogger('cart.purchase-track');

export async function buildPurchaseTrack(): Promise<CartPurchaseTrack | undefined> {
  try {
    const posthogSessionId = await getAnalyticsPlugin().getCurrentSessionId();

    if (!posthogSessionId) {
      return undefined;
    }

    return { posthogSessionId, posthogEventInternalId: crypto.randomUUID() };
  } catch (error) {
    logger.error('Failed to read the analytics session for the cart purchase track', {
      cart: { event: 'analytics_session_failed' },
      error,
    });

    return undefined;
  }
}
